import { gql } from '@apollo/client';
import { CARD_WITH_BLOCKS } from '../card';
import { BLOCK_SETTINGS_FIELD } from '../../fields';

export const VERTICAL_SLIDER_BLOCK = gql`
  fragment VerticalSliderBlockFragment on VerticalSlider {
    autoScrollEnabled
    autoScrollSpeed
    slides {
      ...CardWithBlocksFragment
    }
    blockSettings {
      ...BlockSettingsFieldFragment
    }
    id
    blockName
    blockType
  }
  ${CARD_WITH_BLOCKS}
  ${BLOCK_SETTINGS_FIELD}
`;
